import { useQuery } from "@tanstack/react-query";
import { cleanParams } from "../../../helper/query";
import { IClassEvent } from "../../../models/ClassEvent";
import { IOpenGym } from "../../../models/OpenGym";
import { QUERY_CONSTANTS } from "../../queryKeys";
import { ClassEventService } from "../../../services/class-event.service";

export type UseGetClassEventsWithFiltersByGymIdArgs = {
  gymListingId: string | null;

  userId?: string;
  categoryIds?: string; // "id1,id2"
  eventDate?: string; // YYYY-MM-DD
  timeRanges?: string; // "morning,afternoon,evening"
  classLevels?: string; // "0,1,2"
  minCredits?: number;
  maxCredits?: number;
};

export const useGetClassEventsWithFiltersByGymIdQuery = (
  args: UseGetClassEventsWithFiltersByGymIdArgs
) => {
  const {
    gymListingId,
    userId,
    categoryIds,
    eventDate,
    timeRanges,
    classLevels,
    minCredits,
    maxCredits,
  } = args;

  const params = cleanParams({
    gymListingId,
    userId,
    categoryIds,
    eventDate,
    timeRanges,
    classLevels,
    minCredits,
    maxCredits,
  }) as UseGetClassEventsWithFiltersByGymIdArgs;

  return useQuery<(IClassEvent | IOpenGym)[], Error>({
    queryKey: [QUERY_CONSTANTS.GET_CLASS_EVENTS_BY_GYM_WITH_FILTERS, params],
    enabled: Boolean(gymListingId),
    queryFn: () => ClassEventService.getClassEventsByGymWithFilters(params).then((res) => res.data),
    staleTime: 60_000,
  });
};
